var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"视频播放","close-on-click-modal":false,"close-on-press-escape":false,"before-close":_vm.closeVal},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"prism-player",attrs:{"id":_vm.playerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }